/* ============================================================
   io-polo-styles.js
   Drop in: assets/io-polo-styles.js
   ============================================================ */

(function () {
  function initPoloStyles(wrapper) {
    var track   = wrapper.querySelector('.io-polo-styles__track');
    var prevBtn = wrapper.querySelector('.io-polo-styles__arrow--prev');
    var nextBtn = wrapper.querySelector('.io-polo-styles__arrow--next');

    if (!track || !prevBtn || !nextBtn) return;

    function isMobile() {
      return window.innerWidth <= 749;
    }

    // ── Arrow scroll ────────────────────────────────────────
    function getCardWidth() {
      var card = track.querySelector('.io-polo-styles__card');
      if (!card) return track.offsetWidth;
      var gap = parseInt(getComputedStyle(track).gap) || 16;
      return card.offsetWidth + gap;
    }

    function updateArrows() {
      if (!isMobile()) return;
      var atStart = track.scrollLeft <= 4;
      var atEnd   = track.scrollLeft + track.offsetWidth >= track.scrollWidth - 4;
      prevBtn.disabled = atStart;
      nextBtn.disabled = atEnd;
    }

    /*
     * FIX — Guard arrow clicks against scrolling past the boundaries.
     * scrollBy with smooth behaviour is asynchronous: a second tap can
     * fire before scrollLeft has settled, letting the user scroll past
     * the first or last card.
     *
     * Solution: clamp the target scrollLeft to [0, maxScroll] and use
     * scrollTo instead of scrollBy so the destination is always exact.
     * An isScrolling flag blocks new clicks while the animation runs.
     */
    var isScrolling = false;

    function scrollToPosition(targetLeft) {
      var maxScroll = track.scrollWidth - track.offsetWidth;
      var clamped   = Math.max(0, Math.min(targetLeft, maxScroll));

      // If already at the clamped boundary, nothing to do
      if (Math.abs(track.scrollLeft - clamped) < 2) return;

      isScrolling = true;
      track.scrollTo({ left: clamped, behavior: 'smooth' });

      // scrollend is supported in modern browsers; fall back to a timeout
      // so isScrolling is always cleared even if the event doesn't fire.
      if ('onscrollend' in track) {
        track.addEventListener('scrollend', function onEnd() {
          track.removeEventListener('scrollend', onEnd);
          isScrolling = false;
          updateArrows();
        });
      } else {
        clearTimeout(scrollToPosition._timer);
        scrollToPosition._timer = setTimeout(function () {
          isScrolling = false;
          updateArrows();
        }, 500);
      }
    }

    prevBtn.addEventListener('click', function () {
      if (isScrolling) return;
      scrollToPosition(track.scrollLeft - getCardWidth());
    });

    nextBtn.addEventListener('click', function () {
      if (isScrolling) return;
      scrollToPosition(track.scrollLeft + getCardWidth());
    });

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();

    // ── Nudge: hint that the track is scrollable ─────────────────────────
    // Animates scrollLeft directly (not a CSS transform) so the peek
    // travels through the real scroll container — the 2nd card appears
    // naturally at the right edge, and no clipping occurs.
    // Runs once on mobile when the section enters the viewport.
    // Cancelled immediately if the user touches first.
    if (isMobile() && 'IntersectionObserver' in window) {
      var nudgeDone = false;
      var nudgeRaf  = null;

      function cancelNudge() {
        if (nudgeDone) return;
        nudgeDone = true;
        if (nudgeRaf) cancelAnimationFrame(nudgeRaf);
        track.removeEventListener('touchstart', cancelNudge);
      }

      track.addEventListener('touchstart', cancelNudge, { passive: true });

      // Smooth scroll animation via rAF — eases out to peekPx then eases
      // back to 0. peekPx is 66% of card width (~54vw for an 82vw card).
      function runNudge() {
        var card    = track.querySelector('.io-polo-styles__card');
        var peekPx  = card ? card.offsetWidth * 0.66 : track.offsetWidth * 0.5;
        var totalMs = 1800;
        var halfMs  = totalMs / 2;
        var start   = null;

        // Disable snap temporarily so scroll lands exactly on peekPx mid-animation
        var snapWas = track.style.scrollSnapType;
        track.style.scrollSnapType = 'none';

        function easeInOut(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        }

        function step(ts) {
          if (nudgeDone) {
            track.style.scrollSnapType = snapWas;
            track.scrollLeft = 0;
            return;
          }
          if (!start) start = ts;
          var elapsed = ts - start;

          if (elapsed <= halfMs) {
            // Phase 1: scroll right toward peekPx
            track.scrollLeft = easeInOut(elapsed / halfMs) * peekPx;
          } else if (elapsed <= totalMs) {
            // Phase 2: scroll back to 0
            track.scrollLeft = easeInOut(1 - (elapsed - halfMs) / halfMs) * peekPx;
          } else {
            // Done — restore snap and land at 0
            track.style.scrollSnapType = snapWas;
            track.scrollLeft = 0;
            nudgeDone = true;
            track.removeEventListener('touchstart', cancelNudge);
            return;
          }

          nudgeRaf = requestAnimationFrame(step);
        }

        nudgeRaf = requestAnimationFrame(step);
      }

      var nudgeObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !nudgeDone) {
            nudgeDone = true;
            nudgeObserver.disconnect();
            nudgeDone = false; // reset so runNudge + cancelNudge work correctly
            setTimeout(runNudge, 600);
          }
        });
      }, { threshold: 0.6 });

      nudgeObserver.observe(wrapper);
    }

    // ── Touch / swipe ────────────────────────────────────────
    var touchStartX = 0;
    var touchStartY = 0;
    var isDragging  = false;

    track.addEventListener('touchstart', function (e) {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isDragging  = false;
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (!isMobile()) return;
      var dx = e.touches[0].clientX - touchStartX;
      var dy = e.touches[0].clientY - touchStartY;
      if (!isDragging && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 5) {
        isDragging = true;
      }
      if (isDragging) e.preventDefault();
    }, { passive: false });

    track.addEventListener('touchend', function (e) {
      if (!isMobile() || !isDragging) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      var threshold = 40;
      if (Math.abs(dx) > threshold) {
        scrollToPosition(track.scrollLeft + (dx < 0 ? getCardWidth() : -getCardWidth()));
      }
      isDragging = false;
    }, { passive: true });
  }

  // Init all instances on the page (supports multiple sections)
  document.querySelectorAll('.io-polo-styles').forEach(initPoloStyles);
})();